var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-kp",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kp-a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M5 .1h682.6V512H5.1z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#kp-a)",
    transform: "translate(-4.8 -.1)scale(.93768)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    d: "M776 511.5H-76V.5h852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e5698",
    d: "M776 419H-76v92.5h852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c60000",
    d: "M776 397.6H-76V114.4h852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e5698",
    d: "M776 .6H-76V93h852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M328.5 256c0 63.5-53 115-118.6 115S91.3 319.5 91.3 256s53-114.8 118.6-114.8c65.5 0 118.6 51.4 118.6 114.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c40000",
    d: "m175.8 270.6-57-40.7 71-.2 22.7-66.4 21.1 66.1 71-.4-57.9 41.2 21.3 66.1-57-40.7-58 41.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKp);
export default __webpack_public_path__ + "static/media/kp.1bcf41f7359a335ca2d809e7a77659e3.svg";
export { ForwardRef as ReactComponent };